import { useMutation } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/api-key'

const verifyCaptchaTokenQuery = /** GraphQl */ `
  query VerifyCaptchaToken($token: String!) {
    verifyCaptchaToken(token: $token)
  }
`

export const useVerifyCaptchaMutation = () => {
  return useMutation({
    mutationKey: ['verifyCaptchaToken'],
    mutationFn: async (token: string) => {
      const data = await graphql({
        query: verifyCaptchaTokenQuery,
        variables: {
          token
        }
      })
      return data.verifyCaptchaToken
    }
  })
}

export const useVerifyCaptchaToken = () => {
  const verifyTokenMutation = useVerifyCaptchaMutation()
  const verifyToken = async (token: string) => {
    try {
      const isValid = await verifyTokenMutation.mutateAsync(token)
      return isValid
    } catch (error) {
      console.warn('Error verifying token:', error)
      return false
    }
  }

  return {
    verifyToken
  }
}
